module.exports = __webpack_public_path__ + "img/ZJ5322.6b9b3263.png";